import React, {Component} from 'react';
import PropTypes from 'prop-types';

import ScrollHandler from '../ScrollHandler/ScrollHandler';

class Waypoint extends Component {
    static propTypes = {
        /** String or Number to pass as a parameter to onEnter and onLeave */
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /** Function to call when the component is in View. */
        onEnter: PropTypes.func,
        /** Function to call when the component is no longer in View. */
        onLeave: PropTypes.func,
        /** How many pixels from window bounds should this Lazy Loader unveil itself */
        threshold: PropTypes.number,
        /** Throttle setting in millisconds */
        throttleAmount: PropTypes.number,
        /** Boolean to use window as scroll parent */
        useWindowAsScrollParent: PropTypes.bool,
    }

    static defaultProps = {
        label: '',
        onEnter: () => {},
        onLeave: () => {}
    }

    constructor(props) {
        super(props);
        /* Don't use state so child won't re-render every time we update the visible state */
        this.isVisible = false;
        this.handleLazyLoad = this.handleLazyLoad.bind(this);
    }

    handleLazyLoad(inView) {
        const {label, onEnter, onLeave} = this.props;

        if (inView && !this.isVisible) {
            this.isVisible = true;
            onEnter(label);
        } else if (!inView && this.isVisible) {
            this.isVisible = false;
            onLeave(label);
        }
    }

    render() {
        const {children, label, onEnter, onLeave, ...rest} = this.props; // eslint-disable-line no-unused-vars
        return (
            <ScrollHandler onLazyLoad={this.handleLazyLoad} {...rest}>
                {children}
            </ScrollHandler>
        );
    }
}

export default Waypoint;
